import { NotificationGateway } from './notification-gateway.interface';

const baseUrl = 'gk/projects';
export class HttpNotificationGateway implements NotificationGateway {
  private baseUrl = baseUrl;

  getAllNotificationsByProject(args: { projectId: string }) {
    return { url: `${baseUrl}/${args.projectId}/notifications`, method: 'GET' };
  }

  getAllNotificationTypes() {
    return { url: `${baseUrl}/notification-types`, method: 'GET' };
  }

  postNotification(args: { projectId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.projectId}/notifications`,
      method: 'POST',
      data: args.data,
    };
  }

  deleteNotification(args: { notifId: string }) {
    return {
      url: `${baseUrl}/${args.notifId}/notifications`,
      method: 'DELETE',
    };
  }

  patchNotification(args: { notifId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.notifId}/notifications`,
      method: 'PATCH',
      data: args.data,
    };
  }
}
